import React, { useState } from 'react';
import './Resources.css';

const Resources = () => {
  const [selectedResource, setSelectedResource] = useState(null);

  const resources = [
    {
      date: '2024-03-01',
      dateDisplay: 'MARCH 1, 2024',
      title: "8 Reasons why we decided to move to PCR+ for our UTI's",
      pdfFile: 'Why-PCR-Memo-Rev-1.2.pdf'
    },
    {
      date: '2023-04-18',
      dateDisplay: 'APRIL 18, 2023',
      title: 'Enhanced Urinalysis Reflex to UTI-ID by PCR',
      pdfFile: 'Updated-Reflex-UTI-ID-Memo-Rev-1.1-051523.pdf'
    },
    {
      date: '2023-04-15',
      dateDisplay: 'APRIL 15, 2023',
      title: 'Reasons and Advantages for Developing and Implementing our LTC tailored UTI-ID by PCR',
      pdfFile: 'Memo-UTI-by-PCR-Update-Rev-1.6.pdf'
    },
    {
      date: '2020-01-20',
      dateDisplay: 'JANUARY 20, 2020',
      title: 'UTI Reflex to C&S Testing Changes and Improvements',
      pdfFile: 'UTI-CS-Improvements-Memo-012020.pdf'
    },
    {
      date: '2020-01-18',
      dateDisplay: 'JANUARY 18, 2020',
      title: 'Urine Reflex to C&S Updates (Culture if Indicated)',
      pdfFile: 'DrsLab-Reflex-CS-Memo-011820.pdf'
    },
    {
      date: '2020-01-18',
      dateDisplay: 'JANUARY 18, 2020',
      title: 'Urine Reflex to C&S Updates (Nursing Homes)',
      pdfFile: 'DrsLab-Reflex-CS-NHome-Memo-011820.pdf'
    },
    {
      date: '2018-06-25',
      dateDisplay: 'JUNE 25, 2018',
      title: 'Alert: Postural Pseudo-anemia Phenomenon in Long-Term Care Facilities',
      pdfFile: 'Postural_Pseudoanemia_Memo_062518.pdf'
    },
    {
      date: '2017-03-30',
      dateDisplay: 'MARCH 30, 2017',
      title: 'NT-PROBNP Implementation',
      pdfFile: 'DRSLAB-NT-PROBNP-IMPLEMENTATION.pdf'
    }
  ];

  // Sort by date (newest to oldest)
  const sortedResources = [...resources].sort((a, b) => new Date(b.date) - new Date(a.date));

  const handleResourceClick = (resource) => {
    setSelectedResource(resource);
  };

  const handleClosePreview = () => {
    setSelectedResource(null);
  };

  const handleDownload = (pdfFile) => {
    const link = document.createElement('a');
    link.href = `/${pdfFile}`;
    link.download = pdfFile;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="resources-page">
      <div className="page-header">
        <div className="container">
          <h1>Resources</h1>
          <p>Helpful information and resources for patients and healthcare providers</p>
        </div>
      </div>

      <div className="resources-content">
        <div className="container">
          <div className="resources-list">
            {sortedResources.map((resource, index) => (
              <div 
                key={index} 
                className="resource-item"
                onClick={() => handleResourceClick(resource)}
              >
                <div className="resource-date">{resource.dateDisplay}</div>
                <h3 className="resource-title">{resource.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>

      {selectedResource && (
        <div className="pdf-preview-modal" onClick={handleClosePreview}>
          <div className="pdf-preview-content" onClick={(e) => e.stopPropagation()}>
            <div className="pdf-preview-header">
              <h2>{selectedResource.title}</h2>
              <div className="pdf-preview-actions">
                <button 
                  className="download-button"
                  onClick={() => handleDownload(selectedResource.pdfFile)}
                >
                  Download PDF
                </button>
                <button 
                  className="close-button"
                  onClick={handleClosePreview}
                >
                  ×
                </button>
              </div>
            </div>
            <div className="pdf-preview-body">
              <iframe
                src={`/${selectedResource.pdfFile}#toolbar=1`}
                title={selectedResource.title}
                className="pdf-iframe"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Resources;
